import {API_ROOT_URL, API_URL, PARAMS, APP} from '@/localSettings'

let env = {
  api_root () {
    return API_ROOT_URL
  },
  api_url () {
    return API_URL
  },
  // getSession () {
  //   var req = new XMLHttpRequest()
  //   req.open('GET', document.location, false)
  //   req.send(null)
  //
  //   var data = new Object()
  //
  //   var headers = req.getAllResponseHeaders().toLowerCase()
  //   var aHeaders = headers.split('\n')
  //   var i = 0
  //   for (i = 0; i < aHeaders.length; i++) {
  //     var thisItem = aHeaders[i]
  //     var key = thisItem.substring(0, thisItem.indexOf(':'))
  //     var value = thisItem.substring(thisItem.indexOf(':') + 1)
  //     data[key] = value
  //   }
  // },
  params () {
    let currentURL = (document.URL)

    let iframe = document.getElementsByName('app-iframe')[0]

    if (iframe !== undefined) {
      currentURL = iframe.contentWindow.location.href
    }

    let params = currentURL.split('?')[1]

    if (params === undefined) {
      if (currentURL.indexOf('state=' + APP) < 0) {
        params = 'state=' + APP
      }

      if (PARAMS['override']) {
        params += '&shop=' + PARAMS['shop_url']
        params += '&localhost=' + PARAMS['hash']
      } else {
        params += '&shop=' + window.location.hostname
      }
    } else {
      if (params.indexOf('state=' + APP) < 0) {
        params += '&state=' + APP
      }

      if (params.indexOf('shop') < 0) {
        params += '&shop=' + window.location.hostname
      }
    }

    if (APP === 'consignment-portal') {
      let token = window.$cookies.get('va-refresh-token')

      if (token !== undefined && token !== null) {
        params += '&session=' + token
      }
    }

    return params
  }
}

export default env



// WEBPACK FOOTER //
// ./src/mixins/env.js